/**
 * V331: Auth flow diagnostic logger for Android "stuck on Welcome" investigation.
 * V331.2: Sanitized — never logs raw tokens, codes, or URLs. Booleans and error strings only.
 * Success/lifecycle logs are DEV-only; failure results always use console.error.
 */

const PREFIX = '🔐 AUTH_DIAG';
const DEV = import.meta.env.DEV;

export function logSignInClicked(): void {
  if (DEV) {
    console.debug(`${PREFIX} SIGNIN_CLICKED ts=${Date.now()}`);
  }
}

export function logOAuthOpened(redirectTo: string): void {
  // V331.2: Only log platform hint, never raw URL
  if (DEV) {
    const platform = redirectTo.startsWith('http') ? 'web' : 'native';
    console.debug(`${PREFIX} OAUTH_OPENED platform=${platform} ts=${Date.now()}`);
  }
}

export function logOAuthCallbackReceived(_url: string, hasCode: boolean, hasIdToken: boolean, _params?: Record<string, string>): void {
  // V331.2: Booleans only — never log url, code, id_token, or param values
  if (DEV) {
    console.debug(`${PREFIX} OAUTH_CALLBACK_RECEIVED hasCode=${hasCode} hasIdToken=${hasIdToken} ts=${Date.now()}`);
  }
}

export function logSupabaseSignInResult(success: boolean, errorString?: string): void {
  if (success) {
    if (DEV) {
      console.debug(`${PREFIX} SUPABASE_SIGNIN_RESULT success=true ts=${Date.now()}`);
    }
  } else {
    // Error strings from Supabase are already sanitized — always visible in production
    console.error(`${PREFIX} SUPABASE_SIGNIN_RESULT success=false error="${errorString ?? 'unknown'}" ts=${Date.now()}`);
  }
}
